import React from 'react';
import { useNavigate } from 'react-router-dom';
import emptyListImg from '../../../../assets/images/emptyList.png';
import { DillButton } from '../../../general/Dill';

const NotFound = ({
  title,
  buttonText,
  path,
}: {
  title: string;
  buttonText: string;
  path: string;
}) => {
  const navigate = useNavigate();
  return (
    <div className="flex w-full h-full items-center justify-center px-6 py-16">
      <div className="flex flex-col items-center gap-6 text-center max-w-sm w-full">
        <img
          src={emptyListImg}
          alt=""
          className="w-40 object-contain opacity-40 mix-blend-mode-multiply"
          style={{ mixBlendMode: 'multiply' }}
        />
        <div className="flex flex-col gap-2">
          <h2 className="text-base font-bold GREY_900-CLR">{title}</h2>
          <p className="text-xs text-gray-400 leading-relaxed">
            The page you're looking for doesn't exist or may have been moved.
          </p>
        </div>
        <DillButton onClick={() => navigate(path)} label={buttonText} variant="primary" />
      </div>
    </div>
  );
};

export default NotFound;
